export const version = "/api/v1/";


export const company = {
  companyBase: `${version}company/`,
  companyDocumentDeleteBase: `${version}company_document/`,
};

export const country = {
  countryBase: `${version}country/`,
  unauthoriseCountryBase: `${version}country_list/`,
};

export const currency = {
  currencyBase: `${version}currency/`,
};

//HSM
export const bidHSM = {
  bidHSMBase: `${version}bid_hsm/`,
  bidSubHireHSBase: `${version}bid_subhire_hsm/`,
};

export const unClass = {
  unClassBase: `${version}un_class/`,
};

export const imoClass = {
  imoClassBase: `${version}imo_class/`,
};
export const adrClass = {
  adrClassBase: `${version}adr_class/`,
};
export const bankDetails = {
  bankDetailsBase: `${version}bank_detail/`,
};

export const advanceReport = {
  advanceReportBase: `${version}advance_report/`,
};
export const city = {
  cityBase: `${version}city/`,
};

export const controlTower = {
  controlTowerBase: `${version}control-tower-dashboard/`,
};
export const role = {
  roleBase: `${version}role/`,
};

export const assetAvailability = {
  assetAvailabilitybase: `${version}admin/assets-vehicle-availability-stats-dashboard/`,

  vehicleTypeWiseNewAvalabilityChartBase : `${version}admin/vehicle-availability-dashboard/trip_wise_new_availability/`,
  vehicleTypeWiseAvalabilityChartBase : `${version}admin/vehicle-availability-dashboard/trip_wise_availability/`,
  nextVehicleAvalabilityChartBase:  `${version}admin/vehicle-availability-dashboard/next_availability/`,
};
export const branch = {
  branchBase: `${version}branch/`,
};
export const depot = {
  depotBase: `${version}depot/`,
};

export const user = {
  userBase: `${version}gt_user/`,
  newUserBase: `${version}new_user/`,
  companyRequestBase: `${version}company_request/`,
  changePasswordBase: `${version}change_password/`,
  userPreferencesBase: `${version}user_preferences/`,
};

export const vehicle = {
  vehicleBase: `${version}vehicle/`,
  vehicleDocBase: `${version}vehicle_document/`,
  assetCheckListBase: `${version}asset_checklist/`,
  assetDefectChecklistBase: `${version}defect_asset_checklist/`,
};

export const vehicleCost = {
  vehicleCostBase: `${version}vehicle_cost/`,
};
export const gpsIntegration = {
  gpsProfileBase: `${version}gps_profile/`,
  lsGeofenceBase: `${version}ls_geofence/`,

};

export const vehicleType = {
  vehicleTypeBase: `${version}vehicle_type/`,
};

export const trailer = {
  trailerBase: `${version}trailer/`,
  trailerDocBase: `${version}trailer_document/`,
};

export const lane = {
  laneBase: `${version}lane/`,
  laneRoute: `${version}get_lane_route/`,
};

export const location = {
  locationBase: `${version}location/`,
};

export const bmr = {
  bmrBase: `${version}bmr/`,
  bmrQuotation: `${version}bmr/get_quotation/`,
  bmrRoute: `${version}get_route/`,
};

export const enquiry = {
  rateEnquiry: `${version}customer_rate_enquiry/`,
};

export const customerContract = {
  customerContractBase: `${version}customer_contract/`,
  customerContractChargeBase: `${version}customer_contract_charge/`,
};

export const bidding = {
  bidBase: `${version}bidding/`,
  transporterBidBase: `${version}transporter_bidding/`,
  hsmtransporterBidRate: `${version}bid_hsm/`,
};

export const lrfq = {
  lrfqBase: `${version}admin_lrfq/`,
  lrfqRequestBase: `${version}admin_lrfq_request/`,
  transporterLrfqBase: `${version}transporter_lrfq/`,
};

export const customerInvoice = {
  customerInvoiceBase: `${version}customer_invoice/`,
  creditNoteBase: `${version}credit_note/`,
  debitNoteBase: `${version}debit_note/`,
  misccreditNoteBase: `${version}misc_credit_note/`,
  creditNoteChargeBase: `${version}credit_note_invoice_charge/`,
  singleChargeBase: `${version}delivery_advice_invoice_charge/`,
  creditNoteAttachment: `${version}credit_note_document/`,
  bulkInvoiceLogsBase: `${version}bulk_customer_invoice_logs/`,
};

export const transporterInvoice = {
  transporterInvoiceBase: `${version}transporter_invoice/`,
  legListForInvoice: `${version}leg_list_for_invoice/`,
  transporterInvoiceDoc: `${version}transporter_invoice_document/`,
  legDetailsForInvoice: `${version}invoice_leg/`,
};

export const companyFuelSurcharge = {
  companyFuelSurchargeBase: `${version}company_fuel_surcharge/`,
};
export const companyRequestDoc = {
  companyRequestDocBase: `${version}company_request_doc/`,
};
export const customerAddress = {
  customerAddressBase: `${version}customer_address/`,
};

export const assetType = {
  assetTypeBase: `${version}asset_type/`,
};

export const trailerType = {
  trailerTypeBase: `${version}trailer_type/`,
};

export const containerType = {
  containerTypeBase: `${version}container_type/`,
};

export const containerCategory = {
  containerCategoryBase: `${version}container_category/`,
};

export const driver = {
  driverBase: `${version}driver/`,
  driverDocBase: `${version}driver_document/`,
  driverAppBase: `${version}driver_app/`,
};

export const transporterContract = {
  transporterContractBase: `${version}transporter_contract/`,
};

export const phoneCode = {
  phoneCodeBase: `${version}country_phone_code/`,
};

export const customerOrder = {
  customerOrderBase: `${version}order/`,
  customerOrderSubscriber: `${version}order_subscriber/`,
};

export const deliveryAdvice = {
  deliveryAdviceBase: `${version}da/`,
  deliveryAdviceDocBase: `${version}delivery_advice_document/`,
  deliveryAdviceMilestone: `${version}delivery_advice_milestone/`,
  leg: `${version}leg/`,
  completeLeg: `${version}leg/complete_sub_hire_leg/`,
};

export const subHire = {
  subHireBase: `${version}sub_hire/`,
  subHireLegList: `${version}sub_hire_legs/`,
  transporterSubHireBase: `${version}transporter_sub_hire/`,
};

export const leaseDriverBonusExcel = {
  leaseDriverBonusExcelBase: `${version}lease_driver_bonus_excel/`,
};

export const sapBonusPayout = {
  sapBonusPayoutBase: `${version}sap_driver_processing/`,
  sapDriverBonusPayoutBase: `${version}sap_driver_bonus_payout/`,
};
export const leaseDriver = {
  leaseDriverBase: `${version}lease_driver/`,
};

export const daHazardousCargo = {
  daHazardousCargoBase: `${version}da_hazardous_cargo/`,
};
export const deliveryAdviceCharges = {
  deliveryAdviceChargesBase: `${version}delivery_advice_charge/`,

};

export const deliveryAdviceCostCharges = {
  deliveryAdviceCostChargesBase: `${version}delivery_advice_cost_charge/`,

};
export const legCharges = {
  legChargesBase: `${version}leg_charge/`,
};
export const tripMilestones = {
  tripMilestonesBase: `${version}trip_milestone/`,
};

export const charge = {
  chargeBase: `${version}charge/`,
};

export const tag = {
  tagBase: `${version}tag/`,
};

export const checkList = {
  checkListBase: `${version}check_list/`,
};

export const termsCondtionList = {
  termsCondtionListBase: `${version}terms_and_condition/`,
};

export const driverLeave = {
  driverLeaveBase: `${version}driver_leave/`,
};

export const maintenance = {
  maintenanceBase: `${version}asset_maintenance/`,
};

export const incidentLog = {
  incidentLogBase: `${version}incident_logs/`,
};

export const trip = {
  tripBase: `${version}trip/`,
  legList: `${version}leg_list/`,
  newLegList: `${version}new_leg_list/`,
  legBase: `${version}leg/`,
  legContainerList: `${version}leg_container_list/`,
  legPODBase: `${version}leg_pod/`,
  tripLogs: `${version}trip_logs/`,
  controlTowerList: `${version}control_tower_trip/`,
};

export const tripCustomMilestone = {
  tripCustomMilestoneBase: `${version}trip_custom_milestone/`,

};
export const reports = {
  reportBase: `${version}report/`,
};
export const reportCenter = {
  reportCenterBase: `${version}report_center/`,
};

export const report = {
  reportBase: `${version}report/`,
};

export const department = {
  departmentBase: `${version}department/`,
};

export const quotation = {
  quotationBase: `${version}quotation/`,
};

export const integration = {
  integrationBase: `${version}integration/`,
};

export const milestone = {
  milestoneBase: `${version}milestone/`,
};
export const MilestoneTemplate = {
  MilestoneTemplateBase: `${version}milestone_templates/`,
};

export const nationality = {
  nationalityBase: `${version}nationality/`,
};

export const demoExcelSheetDownload = {
  bulkExcelBase: `${version}get_excel_sample/`,
  uploadCustomerContract: `${version}bulk_customer_contract/`,
  downloadCustomerContract: `${version}bulk_download_apiview/`,
};

export const chat = {
  chatAttachment: `${version}chat_attachment/`,
};
export const SupportTicket = {
  SupportTicketBase: `${version}get_support_response/`,
};

export const emailSubscriber = {
  emailSubscriberBase: `${version}email_subscriber/`,
};

export const activityLogs = {
  logsUrl: version,
};

export const ticket = {
  ticketBase: `${version}ticket/`,
};

export const paymentReceipt = {
  base: `${version}payment_receipt/`,
};

export const dashboard = {
  adminDashboardBase: `${version}admin/dashboard/`,
  transporterDashboardBase: `${version}transporter/dashboard/`,
  customerDashboardBase: `${version}customer/dashboard/`,
};
